import { createStyles, makeStyles } from "@material-ui/core/styles";


export default makeStyles(() => createStyles({
    clip: {
        height: 154,
        width: 205,
        margin: "0 2px",
        borderRadius: 4,
        position: "relative",
    },
    thumbnail: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        borderRadius: 4,
    },
    video: {
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        width: "100%",
        objectFit: "fill",
        borderRadius: 4,
    },
    hidden: {
        display: "none",
    },
}));
